<template>
  <div class="empty db-card-empty">
    <div class="empty-icon"><fa-icon :icon="['fal', icon]" size="2x"/></div>
    <p class="empty-title h6">{{ title }}</p>
    <p class="empty-subtitle">{{ reason }}</p>
    <div class="empty-action" v-if="actionLabel && actionTo">
      <router-link class="btn btn-primary btn-icon btn-icon-left" :to="actionTo">
        <fa-icon :icon="['fal', actionIcon]"/>{{ actionLabel }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'inbox-in',
    },
    title: {
      type: String,
      required: true,
    },
    reason: {
      type: String,
      default: '',
    },
    actionTo: {
      type: [String, Object],
      default: null,
    },
    actionLabel: {
      type: String,
      default: '',
    },
    actionIcon: {
      type: String,
      default: 'chevron-right',
    },
  },
};
</script>
